import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CalendarRange, X } from "lucide-react";

const PRESETS = [["today", "Today"], ["yesterday", "Yesterday"], ["7d", "Last 7 Days"], ["this_month", "This Month"], ["custom", "Custom Range"]];

// Date explorer for Bookings: writes period/start/end/basis to the URL (shared with the list + summary).
export function BookingDateBar() {
  const [sp, setSp] = useSearchParams();
  const period = sp.get("basis") ? sp.get("period") || "" : "";
  const basis = sp.get("basis") || "scheduled";
  const [from, setFrom] = useState(sp.get("start") || "");
  const [to, setTo] = useState(sp.get("end") || "");
  const [custom, setCustom] = useState(period === "custom");
  const apply = (p, extra = {}) => {
    const n = new URLSearchParams(sp);
    ["period", "start", "end", "basis"].forEach((k) => n.delete(k));
    if (p) { n.set("period", p); n.set("basis", extra.basis || basis); }
    if (p === "custom") { n.set("start", extra.start); n.set("end", extra.end); }
    setSp(n, { replace: true });
  };
  const pick = (p) => { if (p === "custom") { setCustom(true); return; } setCustom(false); apply(p); };
  const badRange = from && to && from > to;
  return (
    <div className="mb-4 rounded-xl border border-slate-200 bg-white p-3" data-testid="booking-date-bar">
      <div className="flex flex-wrap items-center gap-2">
        <CalendarRange className="h-4 w-4 text-slate-400" />
        {PRESETS.map(([k, l]) => (
          <button key={k} onClick={() => pick(k)} data-testid={`booking-preset-${k}`}
            className={`rounded-full border px-3 py-1 text-xs font-semibold transition-colors ${(k === "custom" ? custom || period === "custom" : period === k && !custom) ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}>{l}</button>
        ))}
        {period && <button onClick={() => { setCustom(false); setFrom(""); setTo(""); apply(""); }} data-testid="booking-date-clear" className="ml-auto inline-flex items-center gap-1 text-xs font-semibold text-slate-500 hover:text-slate-900"><X className="h-3.5 w-3.5" /> Clear dates</button>}
      </div>
      {custom && (
        <div className="mt-3 flex flex-wrap items-end gap-2">
          <label className="text-xs text-slate-500">From<input type="date" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="booking-date-from" className="mt-1 block rounded-lg border border-slate-200 px-2 py-1.5 text-sm" /></label>
          <label className="text-xs text-slate-500">To<input type="date" value={to} onChange={(e) => setTo(e.target.value)} data-testid="booking-date-to" className="mt-1 block rounded-lg border border-slate-200 px-2 py-1.5 text-sm" /></label>
          <button disabled={!from || !to || badRange} onClick={() => apply("custom", { start: from, end: to })} data-testid="booking-date-apply"
            className="rounded-lg bg-slate-900 px-3 py-2 text-xs font-semibold text-white disabled:opacity-40">Apply</button>
          {badRange && <span className="text-xs text-rose-600" data-testid="booking-date-error">Start date must be on or before end date.</span>}
        </div>
      )}
      {period && (
        <div className="mt-3 flex items-center gap-2 text-xs text-slate-500" data-testid="booking-basis">
          Filter by:
          {[["scheduled", "Appointment date"], ["created", "Date booked"]].map(([k, l]) => (
            <button key={k} onClick={() => { const n = new URLSearchParams(sp); n.set("basis", k); setSp(n, { replace: true }); }} data-testid={`booking-basis-${k}`}
              className={`rounded-md px-2 py-0.5 font-semibold ${basis === k ? "bg-sky-100 text-sky-800" : "text-slate-500 hover:bg-slate-100"}`}>{l}</button>
          ))}
        </div>
      )}
    </div>
  );
}
